import store from "@/vuex/store.js";
import { apiV2Host } from "@/feathers/feathers-client.js";

// Background poll: plain fetch so failures stay silent (ApiClient toasts every error).
export const getLivePlatformNotices = async (app) => {
  // The store token lands after feathers re-auths on boot; the JWT is in storage first.
  const token =
    store.state.auth.accessToken || localStorage.getItem("feathers-jwt");
  if (!token) return null;

  try {
    const res = await fetch(
      `${apiV2Host}/platform-notices?app=${encodeURIComponent(app)}`,
      { headers: { Accept: "application/json", Authorization: `Bearer ${token}` } }
    );
    return res.ok ? await res.json() : null;
  } catch (e) {
    return null;
  }
};

// Public Statuspage summary (CORS: *). Unresolved incidents, plus maintenance
// underway or starting within 24h.
const STATUS_URL = "https://status.voxo.co/api/v2/summary.json";
const DAY_MS = 24 * 60 * 60 * 1000;

export const getStatusIncidents = async () => {
  try {
    const res = await fetch(STATUS_URL);
    if (!res.ok) return null;
    const s = await res.json();
    const soon = Date.now() + DAY_MS;
    return [
      ...s.incidents,
      ...s.scheduled_maintenances.filter(
        (m) =>
          m.status !== "scheduled" ||
          (m.scheduled_for && new Date(m.scheduled_for).getTime() <= soon)
      ),
    ];
  } catch (e) {
    return null;
  }
};
